import React, { Component } from 'react'
import styled from 'styled-components'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import GoogleMap from 'google-map-react';
import mapStyles from '../marketing/GolfCourseMapStyles'
import cssVar from '../../styles/variables'
import failuremark from '../../images/icons/failuremark.svg'

import { MapLegendIndicators, MapIndicators } from '../../images/icons/Icons'

import { Heading2, Text, SelectWrapper, Select } from '../marketing/MarketingStyles'
import OverviewMapMarker from './OverviewMapMarker'

const ITEM_TYPE = {
  MEMBER: {
    ListIcon: MapLegendIndicators.Member,
    Icon: () => <MapLegendIndicators.Member size="21px" style={{ marginLeft: 3, marginTop: -1 }} />,
    Indicator: ( props ) => <MapIndicators.Member { ...props } />,
    infoText: 'bestehendes Mitglied',
  },
  WAITLIST: {
    ListIcon: MapLegendIndicators.Waitlist,
    Icon: () => <MapLegendIndicators.Waitlist size="21px" style={{ marginLeft: 3, marginTop: -1 }} />,
    Indicator: ( props ) => <MapIndicators.Waitlist { ...props } style={{ opacity: 0.7 }} />,
    infoText: 'potentielles Mitglied',
  },
  GOLFCOURSE: {
    ListIcon: MapLegendIndicators.GolfCourse,
    Icon: () => <MapLegendIndicators.GolfCourse size="22px" style={{ marginLeft: 5, marginTop: -1 }} />,
    Indicator: ( props ) => <MapIndicators.GolfCourse { ...props } style={{ marginLeft: -2 }}/>,
    infoText: 'bestehender Golfplatz',
  },
  GOLFCOURSE_REQUEST: {
    ListIcon: MapLegendIndicators.GolfCourseRequest,
    Icon: () => <MapLegendIndicators.GolfCourseRequest size="22px" style={{ marginLeft: 5, marginTop: -1 }} />,
    Indicator: (props) => <MapIndicators.GolfCourseRequest { ...props } style={{ opacity: 0.7, marginLeft: -2 }} />,
    infoText: 'potentieller Golfplatz',
  },
}

@inject('userStore', 'adminStore', 'partnersStore', 'utilStore', 'golfCourseStore')
@observer
class OverviewMap extends Component {

  constructor( props ) {
    super(props)

    this.state = {
      selectedItem: '',
      selectedRegion: '',
      selectedCountry: '',
      coursesCurrent: true,
      coursesRequested: true,
      membersCurrent: true,
      membersWaitlist: true,
      legendVisible: false,
    }
  }

  componentWillMount() {
    this.props.adminStore.getGolfclubrequests()
    this.props.adminStore.getApplicationWaitlist()
    this.props.partnersStore.listPartners()
    this.props.golfCourseStore.getGolfCourses()
  }

  selectItem = (id) => {
    this.setState({ selectedItem: id })
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { golfclubrequests, applicationwaitlist } = this.props.adminStore;
    const courses = this.props.golfCourseStore.golfCourses
    const { regions, countries } = this.props.utilStore
    const { partners } = this.props.partnersStore

    if(!isAdmin && !isLoge) return <div></div>

    const SettingsTagIcon = () => <img src={ failuremark } />
    const SettingsTag = ( { slug, ...props } ) => <SettingsTagWrapper selected={ this.state[ slug ] === true } onClick={ () => { const x = {}; x[ slug ] = !this.state[ slug ]; this.setState(x)}}> { props.children } <SettingsTagIcon /> </SettingsTagWrapper>


    const { selectedCountry, selectedRegion, coursesCurrent, coursesRequested, membersCurrent, membersWaitlist } = this.state

    let filteredRegions = regions ? this.state.selectedCountry ? regions.filter( region => region.country.get("slug") === this.state.selectedCountry ) : regions : undefined
    const selectedRegions = selectedRegion ? [ selectedRegion ] : filteredRegions.map( item => item.slug )

    const items = []

    membersCurrent && partners && partners.forEach((entry, i) => {
      if( !entry.region ) return
      if( selectedRegions.includes(entry.region.slug) ) {
        items.push({
          objectId: "M" + entry.objectId,
          type: ITEM_TYPE.MEMBER,
          title: entry.name,
          location: entry.postcode + ", " + entry.location,
          lat: entry.lat,
          lng: entry.lng,
        })
      }

    });

    membersWaitlist && applicationwaitlist && applicationwaitlist.forEach((entry, i) => {
      if( !entry.region ) return
      if( selectedRegions.includes(entry.region.slug) ) {
        items.push({
          objectId: "W" + entry.objectId,
          type: ITEM_TYPE.WAITLIST,
          title: entry.name,
          location: entry.region.title,
          lat: entry.lat,
          lng: entry.lng,
        })
      }
    });

    coursesRequested && golfclubrequests && golfclubrequests.forEach((entry, i) => {
      if( !entry.region ) return
      if( selectedRegions.includes(entry.region.slug) ) {
        items.push({
          objectId: "R" + entry.objectId,
          type: ITEM_TYPE.GOLFCOURSE_REQUEST,
          title: entry.course_name,
          location: entry.postcode + ", " + entry.city,
          lat: entry.lat,
          lng: entry.lng,
        })
      }
    });

    coursesCurrent && courses && courses.forEach((entry, i) => {
      if( !entry.region ) return
      if( selectedRegions.includes(entry.region.slug) ) {
        items.push({
          objectId: "G" + entry.objectId,
          type: ITEM_TYPE.GOLFCOURSE,
          title: entry.courseName,
          location: entry.region.title,
          lat: entry.lat,
          lng: entry.lng,
        })
      }
    });

    items.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)

    return (
      <OverviewWrapper>
        <Sidebar>

          <Heading2>Mitglieder, Bewerber und Golfclubmap</Heading2>
          <SettingsWrapper>
            <SettingsTitle>Staat</SettingsTitle>
            <SettingsItem>
              <SelectWrapper>
                <Select onChange={ e => this.setState({ selectedCountry: e.target.value, selectedRegion: '' }) } defaultValue="">
                  <option value="">Alle</option>
                  { countries && countries.map((item, index) => <option key={item.slug} value={item.slug}>{item.title}</option>) }
                </Select>
              </SelectWrapper>
            </SettingsItem>

            <SettingsTitle>Region</SettingsTitle>
            <SettingsItem>
              <SelectWrapper>
                <Select onChange={ e => this.setState({ selectedRegion: e.target.value }) } value={ this.state.selectedRegion }>
                  <option value="">Alle</option>
                  { filteredRegions && filteredRegions.map((item, index) => <option key={item.slug} value={item.slug}>{item.title}</option>) }
                </Select>
              </SelectWrapper>
            </SettingsItem>

            <SettingsTitle>Golfclubs</SettingsTitle>
            <SettingsItem>
              <SettingsTagList>
                <SettingsTag slug="coursesCurrent">Bestehende</SettingsTag>
                <SettingsTag slug="coursesRequested">Angefragt</SettingsTag>
              </SettingsTagList>
            </SettingsItem>

            <SettingsTitle>Mitglieder</SettingsTitle>
            <SettingsItem>
              <SettingsTagList>
                <SettingsTag slug="membersCurrent">Bestehende</SettingsTag>
                <SettingsTag slug="membersWaitlist">Warteliste</SettingsTag>
              </SettingsTagList>
            </SettingsItem>
          </SettingsWrapper>

          <ItemList>
            { items && items.map( item => (
              <Item
                onClick={ () => this.selectItem(item.objectId) }
                selected={ this.state.selectedItem === item.objectId }
              >
                <item.type.ListIcon />
                <ItemTitle>{ item.title }</ItemTitle>
                <ItemInformation>{ item.location }</ItemInformation>
              </Item>
            ))}
          </ItemList>

        </Sidebar>

        <MapWrapper>
          <Legend>
            <LegendTitle onClick={ () => this.setState({ legendVisible: !this.state.legendVisible })}><Text>Farblegende</Text> <LegendIndicator open={ this.state.legendVisible }>▲</LegendIndicator></LegendTitle>
            <LegendContent open={ this.state.legendVisible }>
              <LegendContentRow>
                <ITEM_TYPE.GOLFCOURSE.ListIcon />
                <Text>{ ITEM_TYPE.GOLFCOURSE.infoText }</Text>
              </LegendContentRow>
              <LegendContentRow>
                <ITEM_TYPE.GOLFCOURSE_REQUEST.ListIcon />
                <Text>{ ITEM_TYPE.GOLFCOURSE_REQUEST.infoText }</Text>
              </LegendContentRow>
              <LegendContentRow>
                <ITEM_TYPE.MEMBER.ListIcon />
                <Text>{ ITEM_TYPE.MEMBER.infoText }</Text>
              </LegendContentRow>
              <LegendContentRow>
                <ITEM_TYPE.WAITLIST.ListIcon />
                <Text>{ ITEM_TYPE.WAITLIST.infoText }</Text>
              </LegendContentRow>
            </LegendContent>
          </Legend>
          <GoogleMap
            defaultZoom={7}
            defaultCenter={{ lat: 47.6964719, lng: 13.3457347 }}
            bootstrapURLKeys={{ key: 'AIzaSyAhpIoE9Oegu_akwWd0XTSArEANn57Q8fQ' }}
            options={{
              styles: mapStyles,
              disableDefaultUI: false,
            }}
          >
            {
              items && items.map(item =>
                item.lat && item.lng &&
                <OverviewMapMarker
                  key={ item.objectId }
                  lat={ item.lat }
                  lng={ item.lng }
                  data={ item }
                  pointer={ item.type.Indicator }
                  icon={ item.type.Icon }
                  selectCourse={ () => this.selectItem(item.objectId) }
                  deselectCourse={ () => this.selectItem() }
                  selected={ this.state.selectedItem === item.objectId }
                />
              )
            }
          </GoogleMap>
        </MapWrapper>
      </OverviewWrapper>
    )
  }
}

export default OverviewMap

const OverviewWrapper = styled.div `
  height: calc(100vh - 60px);
  min-height: 100%;
  width: calc(100% + 30px);
  margin-left: -15px;
  position: relative;
  display: grid;
  grid-template-columns: 550px auto;
`

const Sidebar = styled.div `
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 75px 50px 50px 50px;
  height: calc(100vh - 60px);
`

const SettingsWrapper = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: 100px auto;
  grid-row-gap: 10px;
  grid-column-gap: 30px;
  padding-bottom: 10px;

  border-bottom: 2px solid ${ cssVar.colors.blue };
  margin-bottom: 10px;
`

const SettingsTitle = styled( Text ) `
  align-self: center;
`

const SettingsItem = styled.div `
  width: 100%;
  height: 100%;
  text-align: right;

  select {
    text-align: right;
  }
`

const SettingsTagList = styled.div `
  width: 100%;
  height: 100%;
`

const SettingsTagWrapper = styled( Text ) `
  display: inline-block;
  cursor: pointer;
  height: 40px;

  margin: 10px 0 10px 10px;
  line-height: 16px;
  padding: 10px 10px 10px 20px;

  border: 2px solid ${ cssVar.colors.lightest_grey };
  border-radius: 5px;

  transition: all ${ cssVar.transitions.basic };

  &:hover {
    background: #FAFAFA;
  }

  img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
    margin-top: -4px;
    filter: brightness(0) opacity(0.5);
    opacity: 0;
    transition: all ${ cssVar.transitions.basic };
  }

  ${ props => props.selected && `
    background: ${ cssVar.colors.lightest_grey };

    img {
      opacity: 1;
    }
  `}

`

const ItemList = styled.div `
  flex: 1;
  width: 100%;
  overflow-y: auto;
`

const Item = styled.div `
  background: ${ cssVar.colors.lightest_grey };
  display: flex;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
  border-left: 0px solid ${ cssVar.colors.gold };
  transition: all .25s linear;

  ${ props => props.selected && `
    border-left: 5px solid ${ cssVar.colors.gold };
    padding-left: 15px;
  `}

  :not(:last-child) {
    margin-bottom: 10px;
  }
`

const Icon = styled.img `
  width: 20px;
  height: 20px;
  background: red;
`

const ItemTitle = styled( Text ) `
  font-weight: bold;
  flex: 1;
  padding: 0 20px;
`

const ItemInformation = styled( Text ) `
  color: ${ cssVar.colors.grey };
  font-style: italic;
  padding: 0;
`

const MapWrapper = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
`

const Legend = styled.div `
  position: absolute;
  z-index: 100;
  ${'' /* background: ${ cssVar.colors.lightest_grey }; */}
  background: white;
  padding: 10px 20px 0 20px;
  right: 60px;
  bottom: 25px;
  border-radius: 5px;
`

const LegendTitle = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  cursor: pointer;
`

const LegendIndicator = styled(Text) `
  transform: rotate(${ props => props.open ? '180deg' : '0deg' });
  transition: all ${ cssVar.transitions.basic };
`

const LegendContent = styled.div `
  border-top: 2px solid ${ cssVar.colors.blue };
  transition: all ${ cssVar.transitions.basic };
  max-height: 300px;
  padding-top: 10px;
  padding-bottom: 20px;
  overflow: hidden;

  ${props => !props.open && `
    max-height: 0;
    border-top: 0px solid ${ cssVar.colors.blue };
    padding: 0;
  `}
`

const LegendContentRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
`



// WEBPACK FOOTER //
// /src/components/admin/OverviewMap.js